var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-inner-loading',{attrs:{"showing":true}},[_c('q-spinner-tail',{attrs:{"size":_vm.size,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }